import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OnlineContractState, featureKey } from '../state/online-contract.state'

export const selectFeatureState = createFeatureSelector<OnlineContractState>(featureKey);

export const selectOnlineContract = createSelector(selectFeatureState, (state) => state.template);
export const selectRequestState = createSelector(selectFeatureState, (state) => state.fetchOnlineContractRequestState);

export const selectSignOnlineRequestState = createSelector(selectFeatureState, (state) => state.signOnlineContractRequestState);

export const selectSignOnlineErrorCode = createSelector(selectFeatureState, (state) => state.signOnlineContractErrorCode);

export const selectSendOnlineInvitationRequestState = createSelector(selectFeatureState, (state) => state.sendOnlineContractInvitationRequestState);

export const selectVisitedRecipientRoles = createSelector( selectFeatureState, (state) => state.visitedRoles );